import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        productionAvailable: true
    },
    {
        path: '/customizations',
        name: 'Customizations',
        component: () => import('../views/Customizations.vue'),
        productionAvailable: true
    },
    {
        path: '/dispersing-notions',
        name: 'DispersingNotions',
        component: () => import('../views/DispersingNotions.vue'),
        productionAvailable: true
    },
    {
        path: '/university-of-cambridge',
        name: 'Cambridge',
        component: () => import('../views/Cambridge.vue'),
        productionAvailable: true
    },
    {
        path: '/languages',
        name: 'Languages',
        component: () => import('../views/Languages.vue'),
        productionAvailable: true
    },
    {
        path: '/reporting',
        name: 'Reporting',
        component: () => import('../views/Reporting.vue'),
        productionAvailable: true
    },
    {
        path: '/applications',
        name: 'Applications',
        component: () => import('../views/Applications.vue'),
        productionAvailable: true
    },
    {
        path: '/privacy',
        name: 'PrivacyPolicy',
        component: () => import('../views/Legal/PrivacyPolicy.vue'),
        productionAvailable: true
    },
    {
        path: '/cookie-policy',
        name: 'CookiePolicy',
        component: () => import('../views/Legal/CookiePolicy.vue'),
        productionAvailable: true
    },
    {
        path: '/data-processor-agreement',
        name: 'DataProcessorAgreement',
        component: () => import('../views/Legal/DataProcessorAgreement.vue'),
        productionAvailable: true
    },
    {
        path: '/sub-processors',
        name: 'SubProcessors',
        component: () => import('../views/Legal/SubProcessors.vue'),
        productionAvailable: true
    },
    {
        path: '/case-studies/',
        name: 'CaseStudies',
        component: () => import('../views/CaseStudies.vue'),
        beforeEnter: (to, from, next) => {
            // router.app.$globalLoading.active = true;
            router.app.$contentful.getEntries({content_type: 'caseStudy'}).then(
                (resp) => {
                    to.params.studies = resp.items;
                    // router.app.$globalLoading.active = false;
                    next();
                }
            ).catch(
                (err) => {
                    console.log(err);
                    next(false);
                }
            );
        },
        productionAvailable: true
    },
    {
        path: '/advisory/',
        name: 'Advisories',
        component: () => import('../views/Advisories.vue'),
        beforeEnter: (to, from, next) => {
            router.app.$contentful.getEntries({content_type: 'advisoryService'}).then(
                (resp) => {
                    to.params.advisories = resp.items;
                    next();
                }
            ).catch(
                (err) => {
                    console.log(err);
                    next(false);
                }
            );
        },
        productionAvailable: true
    },
    {
        path: '/case-studies/:studySlug/:studyId',
        name: 'CaseStudy',
        props: true,
        component: () => import('../views/CaseStudy.vue'),
        beforeEnter: (to, from, next) => {
            router.app.$globalLoading.active = true;
            router.app.$contentful.getEntry(to.params.studyId).then(
                (resp) => {
                    to.params.study = resp.fields;
                    router.app.$globalLoading.active = false;
                    next();
                }
            );
        },
        productionAvailable: true
    },
    {
        path: '/advisory/:advisoryId',
        name: 'Advisory',
        props: true,
        component: () => import('../views/Advisory.vue'),
        beforeEnter: (to, from, next) => {
            router.app.$globalLoading.active = true;
            router.app.$contentful.getEntry(to.params.advisoryId).then(
                (resp) => {
                    to.params.advisory = resp.fields;
                    router.app.$globalLoading.active = false;
                    next();
                }
            );
        },
        productionAvailable: true
    },
    {
        path: '/technical-requirements',
        name: 'TechnicalRequirements',
        props: true,
        component: () => import('../views/TechnicalRequirements.vue'),
        productionAvailable: true
    },
    {
        path: '/pricing',
        name: 'Pricing',
        props: true,
        component: () => import('../views/Pricing.vue'),
        productionAvailable: false
    },
    {
        path: '/get-fitt',
        name: 'GetFitt',
        props: true,
        component: () => import('../views/GetFitt.vue'),
        productionAvailable: true
    },{
        path: '/social-links',
        name: 'SocialLinks',
        props: true,
        component: () => import('../views/LinkTreePage.vue'),
        productionAvailable: true
    },
    {
        path: '/test',
        name: 'Test',
        component: () => import('../views/Demo/Test.vue'),
        productionAvailable: false
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: process.env.NODE_ENV === 'production' ? routes.filter((route) => route.productionAvailable) : routes,
    // routes
});

export default router
